var path = '/client/common/modules/abstract-picker/views/partials/abstract-picker-subheader.html';
var html = "<div class=\"abstract-picker-subheader\">\n    {{ ::vm.objectType }}\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;